import React from 'react';
import { hydrate, render } from "react-dom";
import Template from './template/Template';
import {library} from '@fortawesome/fontawesome-svg-core'
import {fal} from '@fortawesome/pro-light-svg-icons'
import {fab} from '@fortawesome/free-brands-svg-icons'
import {far} from '@fortawesome/pro-regular-svg-icons'
import {fas} from '@fortawesome/pro-solid-svg-icons'
import GoogleAnalytics from "react-ga";
import v4 from "uuid/v4";

const consent = localStorage.getItem('cookieAccepted');

const TRACKING_ID = process.env.REACT_APP_TRACKING_ID;

if (consent === 'yes') {
    GoogleAnalytics.initialize(TRACKING_ID, {
        gaOptions: {
            anonymizeIp: true,
            storeGac: false
        }
    });
} else {
    GoogleAnalytics.initialize(TRACKING_ID, {
        gaOptions: {
            "storage": "none",
            storeGac: false,
            anonymizeIp: true,
            clientId: v4()
        }
    });
}

library.add(fal);
library.add(fab);
library.add(fas);
library.add(far);

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
    hydrate(<Template />, rootElement);
} else {
    render(<Template />, rootElement);
}
